import { render } from "./GraduateYear.vue?vue&type=template&id=9dc89914"
import script from "./GraduateYear.vue?vue&type=script&lang=js"
export * from "./GraduateYear.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__